import { Guid, Nillable } from '@web/utils';
import { AdminCosmeticStatus } from '../enums';

export class AdminCosmeticCollectionItem {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      cosmeticBrandId?: Nillable<Guid>;
      cosmeticBrandName?: Nillable<string>;
      createdAt: Date;
      featuredFileAlt?: Nillable<string>;
      featuredFileUrl?: Nillable<string>;
      id: Guid;
      name: string;
      price?: Nillable<number>;
      slug: string;
      status: AdminCosmeticStatus;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get cosmeticBrandId(): Nillable<Guid> {
    return this.data.cosmeticBrandId;
  }

  public get cosmeticBrandName(): Nillable<string> {
    return this.data.cosmeticBrandName;
  }

  public get featuredFileUrl(): Nillable<string> {
    return this.data.featuredFileUrl;
  }

  public get featuredFileAlt(): Nillable<string> {
    return this.data.featuredFileAlt;
  }

  public get price(): Nillable<number> {
    return this.data.price;
  }

  public get status(): AdminCosmeticStatus {
    return this.data.status;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }
}
